module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reward":"Reward","soldOut":"Sold Out"},"ar":{"reward":"مكافأة","soldOut":"نفذت الكمية"}}')
  delete Component.options._Ctor
}
